import React, { useEffect } from 'react';
import Loader from 'components/loader/Loader';
import ReportCard from 'containers/partials/cards/ReportCard';
import { ROUTE_SESSIONS_ENTITY_SESSION_PERSON } from 'routes/RouteList';
import { generatePath, useParams } from 'react-router-dom';
import { useTestDataContext } from 'contexts/TestDataContext';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import { useSessionContext } from 'contexts/SessionContext';
import DownloadReportsButton from 'containers/partials/session-report-buttons/DownloadReportsButton';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import { PackageSubTypes, PackageTypes } from 'constants';
import ILikeReportCard from 'containers/partials/cards/ReportCards/ILikeReportCard';
import IAmReportCard from 'containers/partials/cards/ReportCards/IAmReportCard';
import SapReportCard from 'containers/partials/cards/ReportCards/SapReportCard';

const SessionPersonReportTab = () => {
  const { entityId, sessionsTab, sessionId, personId } = useParams();
  const person = useEntityContext(s => s.person);
  const { session, options } = useSessionContext();
  const { testDataLoading, testData, hasCompletedIdoILike } =
    useTestDataContext();
  const ability = useAbility(AbilityContext);
  const { setMenuItems, clearAllContext } = useContextMenu();

  useEffect(() => {
    const contextButtons = [];

    if (
      testData &&
      ability.can('download-individual', 'Sessions') &&
      ((session.isIDoILike && hasCompletedIdoILike('individual')) ||
        !session.isIDoILike)
    ) {
      contextButtons.push(
        <DownloadReportsButton
          session={session}
          testData={testData}
          person={person}
          options={options}
          type={'individual'}
        />
      );
    }

    setMenuItems(contextButtons);
    return () => {
      // Cleanup action buttons and context menu items
      clearAllContext();
    };
  }, [session, testData, sessionId, personId, ability, hasCompletedIdoILike]);

  if (testDataLoading) {
    return <Loader />;
  }

  if (session.isTestSetV2 || session.isIDo) {
    return (
      <ReportCard
        compressed
        rootPath={generatePath(ROUTE_SESSIONS_ENTITY_SESSION_PERSON, {
          entityId,
          sessionId,
          sessionsTab,
          personId
        })}
      />
    );
  } else {
    return (
      <LegacyReportCard
        type={session.config.type}
        subtype={session.config.subtype}
      />
    );
  }
};

export default SessionPersonReportTab;

export const LegacyReportCard = ({ type, subtype }) => {
  switch (type) {
    case PackageTypes.ILIKE:
      return <ILikeReportCard />;
    case PackageTypes.SAP:
      switch (subtype) {
        case PackageSubTypes.IAM:
        case PackageSubTypes.DJAS:
        case PackageSubTypes.SGW:
        case PackageSubTypes.VGB:
          return <IAmReportCard />;
        default:
          return <SapReportCard />;
      }
    default:
      return <ILikeReportCard />;
  }
};
